import { createContext } from 'react'

export const EmailProfileMessagesListExpandContext = createContext()
